import { SyntheticEvent } from "react";
import { get } from "lodash";

export const isEnter = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === "Enter";
};

export const isSpace = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === " ";
};

export const isEscape = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === "Escape";
};

export const isArrowUp = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === "ArrowUp";
};

export const isArrowDown = (event: KeyboardEvent | SyntheticEvent) => {
  return get(event, "key") === "ArrowDown";
};

export const handleEnter = (callback: () => void) => (event: KeyboardEvent | SyntheticEvent) => {
  if (isEnter(event)) {
    callback();
  }
};

export const handleEscape = (event: KeyboardEvent | SyntheticEvent, callback: () => void) => {
  if (isEscape(event)) {
    callback();
  }
};
